import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export const OpenNavRouter = [
  //API文档
  {
    hidden: false,
    path: "/apiWord", 
    component: () => import("@/pages/apiWord/index.vue"),
    name: "apiWord",
    redirect:"/create",
    meta: {
      title: "机票接口",
      icon: require("@/assets/img/nav/apiWord.png")
    },
    children: [
      {
        hidden: false,
        path: "/create",
        component: () => import("@/pages/apiWord/create.vue"),
        name: "create",
        meta: {
          title: "创建订单接口"
        }
      },
    ]
  }
];
export const OpenApplication = [
  //我的应用
  {
    hidden: false,
    path: "/application", //应用管理
    component: () => import("@/pages/application/index.vue"),
    name: "application",
    redirect:"/management",
    meta: {
      title: "我的应用",
      icon: require("@/assets/img/nav/shangyemaoyi.png")
    },
    children: [
      {
        hidden: false,
        path: "/management",
        component: () => import("@/pages/application/management.vue"),
        name: "management",
        meta: {
          title: "应用管理"
        }
      },
      {
        hidden: true,
        path: "/managementDetial",
        component: () => import("@/pages/application/managementDetial.vue"),
        name: "managementDetial",
        meta: {
          title: "应用管理"
        }
      }
    ]
  },
]
// 登录
export const whiteRoutes = [
  //未登录首页
  {
    path: "/",
    component: () => import("@/pages/home/indexHome.vue"),
    name: "indexHome"
  },
  //
  {
    path: "/login", //登录页面
    component: () => import("@/pages/Login/index.vue"),
    name: "login"
  },
  {
    path: "/enroll", //注册页面
    component: () => import("@/pages/enroll/index.vue"),
    name: "enroll"
  },
  //首页
  {
    path: "/home",
    component: () => import("@/pages/home/index.vue"),
    name: "home"
  },
  
];

//路由配置赋值给常量constantRoutes
export const constantRoutes = [...whiteRoutes, ...OpenNavRouter,...OpenApplication];
//路由初始化函数赋值给createRouter
const createRouter = () =>
  new Router({
    mode: "history",
    routes: constantRoutes
  });
//路由初始化
const router = createRouter();

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js